import { render } from "./entities.vue?vue&type=template&id=08652907"
import script from "./entities.vue?vue&type=script&lang=js"
export * from "./entities.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__